import { createFileRoute } from "@tanstack/react-router";

import ComingSoon from "../../../components/ComingSoon";
import NoAccess from "../../../components/NoAccess";
import { routePaths, routes } from "../../../constants";
import { useAppState } from "../../../contexts/AppContext";
import { canAccessRoute } from "../../../utils/authorization";

// Deliberately no beforeLoad redirect: users without access land here and
// are told so, instead of being bounced to the dashboard.
export const Route = createFileRoute("/_app/esims/")({
  component: Esims,
});

const esimsRoute = routes.find((route) => route.path === routePaths.esims);

function Esims() {
  const {
    state: { business, businessUserRole },
  } = useAppState();
  const businessType = business?.businessType;

  // Fail closed: canAccessRoute allows access when context is missing (route
  // guards need that during the post-login race), but this page must not.
  const hasAccess =
    !!esimsRoute &&
    !!businessType &&
    !!businessUserRole &&
    canAccessRoute(esimsRoute, businessType, businessUserRole);

  if (!hasAccess) return <NoAccess />;

  return (
    <ComingSoon
      title="eSIMs are coming soon"
      description="Soon you'll be able to buy and manage travel eSIMs for your team here."
    />
  );
}
